import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../../../shadcn/ui/dialog";
import { Button } from "../../../../shadcn/ui/button";
import { Trash2 } from "lucide-react";

const DeleteSpaceModal = ({ show, onClose, onConfirm, isLoading, spaceName }) => {
  return (
    <Dialog open={show} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-gray-900 mb-2">Delete Space</DialogTitle>
          <DialogDescription className="text-gray-600 mb-6">
            Are you sure you want to delete "{spaceName}"? This action cannot be undone and will permanently remove the
            space and all its data.
          </DialogDescription>
        </DialogHeader>

        <div className="flex justify-end space-x-4 pt-4">
          <Button variant="outline" onClick={onClose} disabled={isLoading} className="px-4 py-2">
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isLoading}
            className="px-4 py-2 flex items-center gap-2"
          >
            {isLoading ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Deleting...
              </>
            ) : (
              <>
                <Trash2 className="w-4 h-4" />
                Delete Space
              </>
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteSpaceModal;
